module.exports = __webpack_public_path__ + "img/s2_bg.f4dd17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/UpgradeModal/images/s2_bg.png
// module id = uQnw
// module chunks = 47